module.exports = __webpack_public_path__ + "static/media/NU.a576bb25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NU.svg
// module id = 2232
// module chunks = 7